import {Component, View} from 'angular2/core';

import {AlertService, AlertMessage, MessageType} from './alert.service';

let template = require('./alert.html');
let styles = require('./alert.css');

@Component({
  selector: 'afeb-alert',
})
@View({
  template: template,
  styles: [ styles ],
})
export class Alert {
  constructor(public service: AlertService) {}

  getCssClass(message: AlertMessage) : string {
    var cssClass : string;

    switch (message.type) {
      case MessageType.Primary:
        cssClass = 'alert-primary';
        break;
      case MessageType.Success:
        cssClass = 'alert-success';
        break;
      case MessageType.Warning:
        cssClass = 'alert-warning';
        break;
      case MessageType.Danger:
        cssClass = 'alert-danger';
        break;
      case MessageType.Info:
        cssClass = 'alert-info';
        break;
      case MessageType.Default:
      default:
        cssClass = 'alert-default';
        break;
    }
    return cssClass;
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/alert/alert.ts
 **/